<template>
<div>
  <div class="page">
    <div class="col"><div class="inner">
      <h2 class="size-large">52 Artists <br />52 Actions</h2>
    </div></div>
    <div class="col text size-body"><div class="inner" v-html="$options.filters.markdown(about)"></div></div>
  </div>
  <div class="page supporters">
    <div class="col"><div class="inner">
      <h2>Supporters</h2>
    </div></div>
    <div class="col size-body text supporters__text">
      <div class="kirbytext inner" v-html="$options.filters.markdown(supporters)"></div>
    </div>
  </div>
</div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default Vue.component('RouteAbout', {
  computed: {
    ...mapGetters('site', ['about', 'supporters'])
  }
})
</script>

<style scoped lang="scss">
@import '~@/_variables.scss';

.page {
  background: $color-red;
  display: flex;
  padding-top: 9.6rem;
  padding-bottom: 7.6rem;
  min-height: 100vh;
  @media (max-width: $break-small) {
    display: block;
  }

  &.supporters {
    background: $color-white;
    padding-top: 7.6rem;
  }
}
h2, h3 {
  line-height: 1;
}
h2 {
  text-transform: uppercase;
  margin-bottom: $gutter;
  @media (min-width: #{$break-large + 1px}) {
    br {
      display: none;
    }
  }
}
h3 {
  text-transform: uppercase;
  margin-bottom: 1.2em;
}
.col {
  width: calc(100% * 1 / 2);
  @media (max-width: $break-small) {
    width: 100%;
  }
  .inner {
    padding: $gutter;
    @media (max-width: $break-small) {
      padding-top: 0;
      padding-bottom: 0;
    }
  }
  &.text .inner {
    @media (min-width: #{$break-small + 1px}) {
      padding-left: 0;
    }
  }
}
</style>

<style lang="scss">
@import '~@/_variables.scss';
h3 {
  text-transform: uppercase;
  margin-bottom: 1.2em;
}

.supporters__text .kirbytext {
  img {
    max-width: 100%;
    margin-bottom: 2.4rem;
  }
  ul {
    margin-bottom: 1.2em;
  }
  ul {
    list-style: none;
    li {
      display: inline;
      &:not(:last-of-type):after {
        content: ',';
      }
    }
  }
  hr {
    visibility: hidden;
  }
}
</style>


// WEBPACK FOOTER //
// src/routes/route-about.vue